import React, { useCallback, useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { toastError, pickErrorMsg } from "../lib/feedback";

const fmtData = (iso) => {
  try { return new Date(iso).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return iso; }
};

/* Aba Signature Book: liga/desliga o aviso automático de novidades e mostra os últimos envios. */
export function SBNovidadesPanel({ obra, api }) {
  const [st, setSt] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const load = useCallback(() => api("get", `/obras/${obra.id}/sb-novidades`).then(setSt).catch(() => { }), [api, obra.id]);
  useEffect(() => { load(); }, [load]);
  if (!st) return null;
  const alternar = async () => {
    setSalvando(true);
    try { await api("patch", `/obras/${obra.id}/sb-novidades`, { ativo: !st.ativo }); await load(); }
    catch (e) { toastError("Não foi possível alterar o aviso", { description: pickErrorMsg(e) }); }
    finally { setSalvando(false); }
  };
  const aviso = !st.whatsapp_configurado ? "WhatsApp não configurado no sistema." : !st.tem_telefone ? "Cadastre o telefone do cliente para o aviso funcionar." : null;
  return (
    <div className="panel" style={{ marginTop: 24 }} data-testid="sb-novidades-panel">
      <div className="panel-head">
        <div>
          <div className="panel-eyebrow"><BellRing size={11} style={{ verticalAlign: "-1px" }} /> WhatsApp automático</div>
          <h3 className="panel-title">Aviso de <em>novidades</em></h3>
        </div>
        <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", fontSize: 12, color: "var(--ink-2)" }}>
          <input type="checkbox" checked={st.ativo} disabled={salvando} onChange={alternar} data-testid="sb-novidades-toggle" />
          {st.ativo ? "Ligado" : "Desligado"}
        </label>
      </div>
      <p style={{ fontSize: 13, color: "var(--ink-3)", lineHeight: 1.7, margin: 0 }}>
        Quando novas fotos ou vídeos entram na cronologia do Signature Book, o cliente recebe uma mensagem formal com o link,
        entre 8h e 20h (Brasília), no máximo uma vez a cada 24h.
      </p>
      {aviso && <div style={{ marginTop: 10, fontSize: 12, color: "#c47a7a" }} data-testid="sb-novidades-aviso">{aviso}</div>}
      <div style={{ display: "flex", gap: 24, marginTop: 14, fontSize: 12, color: "var(--ink-2)", flexWrap: "wrap" }}>
        <span>Novidades aguardando aviso: <strong style={{ color: "var(--gold)" }} data-testid="sb-novidades-pendentes">{st.pendentes}</strong></span>
        <span>Último aviso: <strong data-testid="sb-novidades-ultimo">{st.ultimo_envio ? fmtData(st.ultimo_envio) : "nenhum"}</strong></span>
      </div>
      {st.envios.length > 0 && (
        <div style={{ marginTop: 14 }} data-testid="sb-novidades-envios">
          {st.envios.map(e => (
            <details key={e.id} style={{ borderTop: "1px solid var(--line)", padding: "8px 0", fontSize: 12, color: "var(--ink-2)" }}>
              <summary style={{ cursor: "pointer" }}>{fmtData(e.at)} · {e.novos} novidade(s)</summary>
              <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", color: "var(--ink-3)", margin: "8px 0 0" }}>{e.mensagem}</pre>
            </details>
          ))}
        </div>
      )}
    </div>
  );
}
